import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import MdiSvg from "@yeliulee/vue-mdi-svg/v3" // or just "@yeliulee/vue-mdi-svg"

createApp(App)
    .use(router)
    .use(MdiSvg)
    .mount('#app')